import apiClient from '../lib/apiClient';

// Get regularization requests
const getRegularizationRequests = async (filters = {}) => {
  try {
    const result = await apiClient.get('/attendance-regularization', filters);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch regularization requests' };
  }
};

// Create regularization request
const createRegularizationRequest = async (data) => {
  try {
    const result = await apiClient.post('/attendance-regularization/create', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create regularization request' };
  }
};

// Approve regularization request
const approveRequest = async (requestId) => {
  try {
    const result = await apiClient.post('/attendance-regularization/approve', { id: requestId });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to approve request' };
  }
};

// Reject regularization request
const rejectRequest = async (requestId, rejectionReason) => {
  try {
    const result = await apiClient.post('/attendance-regularization/reject', { 
      id: requestId, 
      rejection_reason: rejectionReason 
    });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to reject request' };
  }
};

export default {
  getRegularizationRequests,
  createRegularizationRequest,
  approveRequest,
  rejectRequest
};

